<template>
  <div>
    <div class="text-main-color h2">
      Privacy Policy
    </div>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-12">
            <h2 class="display-3">Snapture 服務條款</h2>
            <h3 class="text-lg-left mt-lg">第一條 服務條款之適用</h3>
            <p class="lead text-muted text-lg-left">● 本程式及網頁是由Pixi DIY Studio Limited 公司（以下稱「本公司」）運營並提供服務，旨在為會員用戶（以下稱「用戶」）提供自助式設計等服務。使用本服務之用戶，視為已同意遵守本服務條款之內容。</p>

            <h3 class="text-lg-left mt-lg">第二條 服務內容</h3>
            <p class="lead text-muted text-lg-left">● 本公司提供之服務包括以下內容：</p>
            <p class="lead text-muted text-lg-left ml-4">1. 允許用戶購買本公司販售之商品（包括且不限於亞克力膠加工商品、相關商品）之服務。</p>
            <p class="lead text-muted text-lg-left ml-4">2. 允許用戶將所上載之設計或圖像數碼化，進行加工（包括但不限於印刷、切割等）。</p>
            <p class="lead text-muted text-lg-left ml-4">3. 其他本公司未來可能新增之服務。</p>

            <h3 class="text-lg-left mt-lg">第三條 會員註冊</h3>
            <p class="lead text-muted text-lg-left">● 用戶必須完成所需的註冊手續，方可使用本服務。如使用本服務，請遵守以下條款。本公司有權在未經事先通知或同意下拒絕或撤銷用戶的帳戶。</p>
            <p class="lead text-muted text-lg-left ml-4">1. 請在註冊表格中輸入與用戶相關的真實且正確的資料。本公司不允許偽報或虛假記載申報及報告內容。</p>
            <p class="lead text-muted text-lg-left ml-4">2. 請輸入可以聯繫到用戶的信息。在使用者有資料變更時，請更新其個人信息。</p>
            <p class="lead text-muted text-lg-left ml-4">3. 請不要進行對本程式進行任何惡意等不正當行為，或故意對本公司造成不利或干擾。</p>
            <p class="lead text-muted text-lg-left ml-4">4. 其他由本公司判定為不適當的行為。</p>
            <p class="lead text-muted text-lg-left">● 如用戶採取了上述處理措施，導致其他用戶無法使用本服務，且因此導致其他用戶遭受損害，本公司不承擔任何責任，但保留追討權利。</p>

            <h3 class="text-lg-left mt-lg">第四條 會員資訊</h3>
            <p class="lead text-muted text-lg-left">● 如用戶在申請本服務註冊時提供的姓名、電話號碼、電子郵件地址、住址、配送地址發生變更，用戶應立即按照本公司所規定的方式進行變更。</p>
            <p class="lead text-muted text-lg-left">● 如因未進行變更登錄而導致的損失，除本公司存在故意或重大過失外，本公司不承擔任何責任。</p>
            <p class="lead text-muted text-lg-left">● 用戶必須對持有註冊資訊的帳戶進行管理，並對其使用承擔一切責任，並確保不會對本公司造成任何損害。</p>
            <p class="lead text-muted text-lg-left">● 如會員資訊未經許可被第三方使用，或存在洩露的風險，請立即重新設置密碼。</p>

            <h3 class="text-lg-left mt-lg">第五條 確認事項</h3>
            <p class="lead text-muted text-lg-left">● 如用戶通過本服務進行加工商品的訂購，用戶應同意以下事項：</p>
            <p class="lead text-muted text-lg-left ml-4">o 由於本服務通過iOS應用程式和網頁瀏覽器進行訂購，因此顯示在螢幕上的RGB會轉換為CMYK進行加工，因此可能會產生差異。</p>
            <p class="lead text-muted text-lg-left ml-4">o 切割的精度無法完全保證，差異可能小於5毫米。</p>
            <p class="lead text-muted text-lg-left ml-4">o 加工位置是由人工進行的，因此可能會有輕微的位置偏差。</p>
            <p class="lead text-muted text-lg-left ml-4">o 如因上述差異或誤操作而導致的訂單退貨或更換，本公司將無法退款。</p>

            <h3 class="text-lg-left mt-lg">第六條 本服務之中斷</h3>
            <p class="lead text-muted text-lg-left">● 如符合以下情況，本公司有權暫時中斷本服務，並無需事先通知或獲得同意：</p>
            <p class="lead text-muted text-lg-left ml-4">o 定期或緊急維護時；</p>
            <p class="lead text-muted text-lg-left ml-4">o 因火災、停電、地震、火山爆發、洪水、海嘯、戰爭、政變、暴動、騷亂、勞資糾紛等原因造成本服務無法提供時；</p>
            <p class="lead text-muted text-lg-left ml-4">o 因供應商無法履行或無法供應貨物等原因造成本服務無法提供時；</p>
            <p class="lead text-muted text-lg-left ml-4">o 因通訊線路事故、使用困難（包括網路恐攻等）等原因造成本服務無法提供時；</p>
            <p class="lead text-muted text-lg-left ml-4">o 其他經營上、技術上、本公司認為暫時中斷本服務為必要之情況。</p>

            <h3 class="text-lg-left mt-lg">第七條 註冊資料之處理</h3>
            <p class="lead text-muted text-lg-left">● 本公司僅會使用註冊申請、資料變更及其他與本服務相關的資訊，並限於提供本服務之目的，並不向第三方透露。但為了向會員提供服務、改善服務內容、促進服務，以及確保服務的健全和順利運營，本公司可以利用註冊資料並透過電子郵件等方式向會員提供信息（包括廣告），但會員可以通過本公司指定的方式通知本公司停止接收資訊。</p>

            <h3 class="text-lg-left mt-lg">第八條 商品訂單</h3>
            <p class="lead text-muted text-lg-left">● 如遇到長期無法預期的原因導致無法交付商品，本公司有權取消訂單。</p>
            <p class="lead text-muted text-lg-left">● 本公司將以遵守各種法律、規定和指導方針的方式處理提供給本服務的所有信息。</p>
            <p class="lead text-muted text-lg-left">● 用戶應保證用戶發送給本公司的設計等訂單數據和其他加工所需信息包括第三方名稱、肖像、版權和其他權利沒有侵犯他人權利。對於因印刷引起或相關的任何爭議、異議申述等，本公司一概不負責。</p>

            <h3 class="text-lg-left mt-lg">第九條 取消和更改</h3>
            <p class="lead text-muted text-lg-left">● 在商品訂單確定後，經入款確認後，訂單將被確定。一旦確定，由於將即時進入製造過程，因此無法取消，更改及退款。根據付款方式（包括未來新增的付款方式），有些商品可能在訂購時已被即時確定訂單。</p>
            <p class="lead text-muted text-lg-left">● 不過，根據本公司的特定產品條件和程序，可能部分可取消或更改訂單，這需要跟本公司職員商討。</p>

            <h3 class="text-lg-left mt-lg">第十條 退貨政策</h3>
            <p class="lead text-muted text-lg-left">● 除以下商品外，其他不接受退貨(包括需特定定製的個別印刷商品)。</p>
            <p class="lead text-muted text-lg-left ml-4">o 商品送達後出現損壞、污漬、破損等</p>
            <p class="lead text-muted text-lg-left ml-4">o 附屬的包裝袋等保護商品的包裝材料損壞</p>
            <p class="lead text-muted text-lg-left">● 如收到貨件後7天內與本公司聯繫，可根據特定手續更換商品。如有任何爭議，本公司保留最終決定權。</p>

            <h3 class="text-lg-left mt-lg">第十一條 商品交付</h3>
            <p class="lead text-muted text-lg-left">● 如果用戶無法接收郵寄的商品並退回本公司。在此情況下，再次發送商品可能需要支付額外手續費用。</p>
            <p class="lead text-muted text-lg-left">● 商品的交付方付應依照您註冊的送貨地址進行。</p>
            <p class="lead text-muted text-lg-left">● 本服務費用的支付方式將由本公司指定。用戶在購買商品時，需支付商品價格、運費及其他由本公司指定的費用總額。</p>

            <h3 class="text-lg-left mt-lg">第十二條 責任限制</h3>
            <p class="lead text-muted text-lg-left">● 對於因使用本服務或無法使用本服務而對用戶造成的損害，本公司僅對本協議明確規定的責任負責。本公司不對用戶承擔任何其他責任。此外，無論何種情況下，本公司對用戶的損害賠償責任均僅限於通常和直接的損害賠償，且該賠償額不得超過用戶支付給本公司的總費用。</p>

            <h3 class="text-lg-left mt-lg">第十三條 知識產權</h3>
            <p class="lead text-muted text-lg-left">● 本服務所提供的各種內容的知識產權（包括但不限於專利權、實用新型權、外觀設計權、商標權、著作權、公開權及其他知識產權）等所有權均歸屬於本公司或各自內容的權利人。此外，本公司所涉及的程式以及各種內容的選擇或排列等所產生的著作權及其他知識產權均歸屬於本公司。</p>
            <p class="lead text-muted text-lg-left">● 用戶通過本服務進行創作活動產生的著作權及其他權利仍歸屬於用戶。然而，本公司有權使用包括用戶姓名、聯繫方式等個人信息之外的加工信息（包括設計等）作為本服務的廣告、宣傳和運營之用。</p>
            <p class="lead text-muted text-lg-left">● 用戶對於上項所述的加工信息的使用有權作出拒絕。</p>
            <p class="lead text-muted text-lg-left">● 對於本公司銷售的商品中使用的加工信息，本公司不保證其內容的可靠性、真實性、合法性，本公司不承擔任何責任。</p>
            <p class="lead text-muted text-lg-left">● 即使用戶退出本服務或本協議因任何原因終止，本條款的規定仍然有效。</p>

            <h3 class="text-lg-left mt-lg">第十四條 禁止事項</h3>
            <p class="lead text-muted text-lg-left">● 用戶不得進行以下行為:</p>
            <p class="lead text-muted text-lg-left ml-4">o 未經權利人許可而傳送含有著作權、姓名、肖像等知識產權（包括商標、商號、商品，知識產權等）的加工信息，或進行可能被評估為侵犯知識產權或違反其他法例的一切行為。</p>
            <p class="lead text-muted text-lg-left ml-4">o 傷害第三方的經濟、精神利益，威脅、侵犯名譽、信用、隱私或肖像權，進行騷擾、誹謗、淫穢、品行不端、令人反感、涉及種族或人種歧視等問題的行為，或透過本服務向他人發佈、公開、提供或傳送該等信息或可能存在此等情況的行為。</p>
            <p class="lead text-muted text-lg-left ml-4">o 傳送涉及兒童色情、淫穢、暴力或可能違反公共秩序的加工信息，或對未成年人造成傷害的行為。</p>
            <p class="lead text-muted text-lg-left ml-4">o 各種妨礙本服務運營的惡意及犯罪行為。</p>
            <p class="lead text-muted text-lg-left ml-4">o 透過非法使用他人信用卡的方式使用本服務。</p>
            <p class="lead text-muted text-lg-left ml-4">o 轉售、再銷售或以營利為目的透過本服務購買商品的行為。</p>
            <p class="lead text-muted text-lg-left ml-4">o 其他本公司認為不適當的行為。</p>
            <p class="lead text-muted text-lg-left">● 本公司尊重第三方的知識產權，用戶也應盡力尊重第三方的知識產權。</p>

            <h3 class="text-lg-left mt-lg">第十五條 會員資料的停止與刪除</h3>
            <p class="lead text-muted text-lg-left">● 若用戶違反使用條款的內容，或違反前一條的禁止事項等，被本公司或代理人判定為不當行為時，本公司有有權暫停或刪除該帳號。</p>
            <p class="lead text-muted text-lg-left">● 當本公司停止或刪除特定帳戶時，將刪除與該帳戶相關的資訊、儲存的資料和檔案，並禁止未來訪問該資訊、資料和檔案。</p>
            <p class="lead text-muted text-lg-left">● 當本公司刪除會員資料時，不對該用戶承擔任何責任。</p>

            <h3 class="text-lg-left mt-lg">第十六條 本服務的變更和廢止</h3>
            <p class="lead text-muted text-lg-left">● 本公司有權自行決定，在不承擔任何責任的情況下，隨時變更、更新或廢止全部或部分的服務，並在變更、更新或廢止之前合理努力通知用戶。</p>

            <h3 class="text-lg-left mt-lg">第十七條 免責事項</h3>
            <p class="lead text-muted text-lg-left">● 本公司不對用戶因使用本服務或無法使用本服務所造成的任何損害（包括利潤損失、機會損失等）承擔任何責任。</p>
            <p class="lead text-muted text-lg-left">● 除了在家長陪同下，小孩或幼兒應避免接觸產品以防窒息或誤食等意外。</p>
            <p class="lead text-muted text-lg-left">● 對於通訊線路、電腦等的故障，包括但不限於系統中斷、延遲、停止、數據丟失等，因非法訪問數據而導致的損失，以及本服務對用戶造成的其他損失，本公司不負損害賠償責任。</p>
            <p class="lead text-muted text-lg-left">● 如果用戶違反本服務條款或有關知識產權的法律或其他協議，導致第三方受到損害，本公司不對第三方或用戶承擔任何責任。本公司有權向用戶請求因其違反協議對本公司造成的損害賠償。</p>
            <p class="lead text-muted text-lg-left">● 由於本服務的特性，可能會出現檢查等檢查工作或製造過程中的延遲等情況，但對於這些事件，本公司不承擔任何責任。</p>

            <h3 class="text-lg-left mt-lg">第十八條 信息公開</h3>
            <p class="lead text-muted text-lg-left">● 根據法律要求披露、收到法院、警察等公共機構或律師會的正式諮詢，或者當本公司認為必要為保護自身權益、利益、名譽等時，本公司可能會披露用戶的信息。</p>
            <p class="lead text-muted text-lg-left">● 如果披露加工信息侵害了第三方的權利，或者為了保護本服務或第三方的財產、權利、生命、身體、業務或公共利益，本公司也可能會披露用戶信息。</p>

            <h3 class="text-lg-left mt-lg">第十九條 個人資料保護</h3>
            <p class="lead text-muted text-lg-left">● 本服務將根據本公司的私隱政策處理個人資料。</p>

            <h3 class="text-lg-left mt-lg">第二十條 本規約之修改</h3>
            <p class="lead text-muted text-lg-left">● 本公司可在未經用戶事先同意的情況下任意修改本服務條款。</p>
            <p class="lead text-muted text-lg-left">● 本公司可訂立補充服務條款以補充本服務條款。</p>
            <p class="lead text-muted text-lg-left">● 修改本服務條款或補充服務條款時，本公司會在本服務上公開或以本公司認為合適的方式通知用戶，並自公開或通知之時生效。在此情況下，用戶應遵循修改後的本服務條款及補充服務條款，並予以承認。</p>

            <h3 class="text-lg-left mt-lg">第二十一條 可分性</h3>
            <p class="lead text-muted text-lg-left">即便本服務條款的某一條款被視為無效或不可執行，本合約條款的其他部分仍然有效並受到影響。本服務條款的各條款應在法律允許的最大範圍內具有強制力。</p>

            <h3 class="text-lg-left mt-lg">第二十二條 準據法及管轄法院</h3>
            <p class="lead text-muted text-lg-left">除非另有規定，本服務條款的成立、有效性、履行和解釋均適用香港法律。</p>
            <p class="lead text-muted text-lg-left">2024年6月25日修訂</p>


          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "terms_conditions"
}
</script>

<style scoped>

</style>
